<div [dir]="cService.selectedLanguage?.isRtl ? 'rtl' : 'ltr'" fxLayout='row' fxFill *ngIf='cService.isPcViewport'>
  <mat-drawer-container class='drawer-container' autosize>
    <mat-drawer #drawer class='dialog-sidenav' mode='side' [(opened)]='paneOpened'>
      <ng-content></ng-content>
    </mat-drawer>
  </mat-drawer-container>

  <div class='custom-drawer' (click)='toggleDrawer()'>
    <button mat-mini-fab vrm-raised-button class='drawer-toggle'>
      <mat-icon class='rotate-item' [class.right]='paneOpened'>chevron_right</mat-icon>
    </button>
  </div>
</div>
